import REDUX_DOMAIN from '../../constants/domain'
import createDomainListReduxUtil from '../create-domain-list'
import getClassNameReduxUtil from '../get-class-name'
import getDomainListPathsReduxUtil from '../get-domain-list-path'
import { getIdReduxUtil } from '../get-id'
import removeReferenceUtil from '../../../references/utils/remove'
import setUtil from '../../../../utils/set'
import { getObjectUtil, uniqArrayUtil } from 'packages/src'

/**
 * Adds a instance to the DomainList(s).
 * NOTE: If the DomainList key is `all`, the instance will also be deleteed to
 * the sectioned DomainLists.
 * e.g. `state.articles.${category}` => `state.articles.nutrition`
 * @param   {Object} props
 *          {Object} props.state
 *          {Instance} props.instance
 * @returns {Object}
 */
function deleteInstanceFromDomainListsReduxUtil (props) {
  const {
    instance
  } = props
  let { state } = props

  const id = getIdReduxUtil(instance)
  const domainListPaths = getDomainListPathsReduxUtil(instance)

  domainListPaths.forEach(domainListPath => {
    // Get the DomainList
    const domainList = (
      getObjectUtil(state, domainListPath || 'all') || createDomainListReduxUtil()
    )
    const domainListData = getObjectUtil(domainList, 'data') || []

    // Set the sorted instance
    const domainPath = REDUX_DOMAIN[getClassNameReduxUtil(instance)]
    const domain = getObjectUtil(state, domainPath)
    if (!domain) {
      console.error(
        `domain not found with domainPath ${domainPath}, domainListPath ${domainListPath} and instance: `,
        instance
      )
      return state
    }

    // Add the instance to the DomainList
    const newInstances = domainListData.filter(idParam => idParam !== id)

    // Add the instance to the DomainList
    const newDomainList = setUtil(domainList, 'data', uniqArrayUtil(newInstances))

    // Update the DomainList
    const newState = setUtil(state, domainListPath, newDomainList)

    const deleteReferenceObj = removeReferenceUtil({
      instance,
      referencePath: `${domainListPath}.data`,
      state: newState
    })

    if (!deleteReferenceObj) {
      state = newState
    } else {
      state = deleteReferenceObj.state
    }
  })
  return state
}

export { deleteInstanceFromDomainListsReduxUtil }
